// extracted by mini-css-extract-plugin
module.exports = {"root":"_1o6MN","success":"_2ZURN","info":"_2U6ju","warning":"ycgQE","danger":"_2wRZf"};